import React from 'react';
import { PlugIcon, ZapIcon } from 'lucide-react';
const TOP_OUTLETS = [{
  name: '에어컨',
  location: '거실',
  usage: 12.4,
  percent: 100
}, {
  name: '전기히터',
  location: '안방',
  usage: 8.2,
  percent: 66
}, {
  name: '냉장고',
  location: '주방',
  usage: 5.1,
  percent: 41
}];
export function TopOutletWidget() {
  return <div className="glass-panel rounded-2xl p-4 flex flex-col gap-3 flex-1 h-full" data-id="element-380">
      <div className="flex items-center justify-between" data-id="element-381">
        <div className="flex items-center space-x-2 text-slate-400" data-id="element-382">
          <PlugIcon className="w-4 h-4 text-violet-400" data-id="element-383" />
          <span className="text-[11px] font-medium uppercase tracking-wider" style={{
          fontSize: "12px"
        }} data-id="element-384">
            사용량 TOP 콘센트
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-2.5 flex-1 justify-center" data-id="element-385">
        {TOP_OUTLETS.map((outlet, i) => <div key={outlet.name} className="flex items-center gap-3" data-id="element-386">
            {/* Rank */}
            <div className={`
              w-5 h-5 rounded-md flex items-center justify-center text-[10px] font-mono font-bold flex-shrink-0
              ${i === 0 ? 'bg-amber-500/20 text-amber-400' : 'bg-white/5 text-slate-500'}
            `} data-id="element-387">
              {i + 1}
            </div>

            {/* Info + Bar */}
            <div className="flex-1 min-w-0" data-id="element-388">
              <div className="flex items-center justify-between mb-1" data-id="element-389">
                <div className="flex items-center gap-1.5" data-id="element-390">
                  <span className="text-xs text-white font-medium truncate" data-id="element-391">
                    {outlet.name}
                  </span>
                  <span className="text-[9px] text-slate-600 font-mono" style={{
                fontSize: "10px"
              }} data-id="element-392">
                    {outlet.location}
                  </span>
                </div>
                <div className="flex items-center gap-1 flex-shrink-0" data-id="element-393">
                  <ZapIcon className={`w-2.5 h-2.5 ${i === 0 ? 'text-amber-400' : 'text-slate-600'}`} data-id="element-394" />
                  <span className={`text-xs font-mono font-bold ${i === 0 ? 'text-amber-400' : 'text-slate-400'}`} data-id="element-395">
                    {outlet.usage}
                    <span className="text-[8px] text-slate-600 ml-0.5" data-id="element-396">
                      kWh
                    </span>
                  </span>
                </div>
              </div>
              <div className="w-full bg-slate-800 h-1 rounded-full overflow-hidden" data-id="element-397">
                <div className={`h-full rounded-full transition-all duration-1000 ${i === 0 ? 'bg-amber-500/70' : 'bg-slate-600/50'}`} style={{
              width: `${outlet.percent}%`
            }} data-id="element-398" />
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}